import template from './templates/custom-error.tmpl';
import localize from   '../../core/localize';
import AppSettings from '../../core/AppSettings';

export default class CustomError {
	constructor (parentElement, errDescription, opt = {}) {
		this.parentElement = parentElement;
		this.renderedTemplate = template;
		this.parentElement.innerHTML = this.renderedTemplate;
		this.el = this.parentElement.querySelector(".error-view");

		// Title and descriptions
		this.errDescription = errDescription;
		this.errorTitle = opt.errorTitle; 

		if (AppSettings.Language) {
			localize(parentElement, AppSettings.Language);
			this.el.querySelector('.error--title').innerHTML = this.errorTitle;
			this.el.querySelector('.error--text').innerHTML =  this.errDescription;
		}

	}
}